<template>
    <span :class="textClass">{{ row.Borc  || '-' }}</span>
</template>

<script>
export default {
    props:{
        fields:[String,Number],
        row:Object
    },
    computed:{
        textClass(){
            return 'text-primary font-weight-bolder'
           
        }
    }
}
</script>